const u = up.util;
const e = up.element;
up.Selector = class Selector {
    constructor(selector, elementOrDocument, options = {}) {
        var _a;
        this._filters = [];
        let matchingInExternalDocument = elementOrDocument && !document.contains(elementOrDocument);
        if (!matchingInExternalDocument && !options.destroying) {
            this._filters.push(up.fragment.isNotDestroying);
        }
        this._ignoreLayers = matchingInExternalDocument || options.layer === 'any' || up.layer.count === 1;
        let expandTargetLayer;
        if (this._ignoreLayers) {
            expandTargetLayer = up.layer.root;
        }
        else {
            (_a = options.layer) !== null && _a !== void 0 ? _a : (options.layer = u.presence(elementOrDocument, u.isElement));
            this._layers = up.layer.getAll(options);
            if (!this._layers.length)
                throw new up.CannotMatch(["Unknown layer: %o", options.layer]);
            this._filters.push((match) => u.some(this._layers, (layer) => layer.contains(match)));
            expandTargetLayer = this._layers[0];
        }
        this._selectors = up.fragment.expandTargets(selector, Object.assign(Object.assign({}, options), { layer: expandTargetLayer }));
        this._unionSelector = this._selectors.join() || 'match-none';
    }
    matches(element) {
        return e.elementLikeMatches(element, this._unionSelector) && this._passesFilter(element);
    }
    closest(element) {
        return this._filterOne(element.closest(this._unionSelector));
    }
    descendants(root = document) {
        return this._filterMany(root.querySelectorAll(this._unionSelector));
    }
    firstDescendant(root) {
        if (this._ignoreLayers) {
            root || (root = document);
            return this._firstSelectorMatch((selector) => root.querySelectorAll(selector));
        }
        else {
            return u.findResult(this._layers, (layer) => {
                return this._firstSelectorMatch((selector) => e.subtree(layer.element, selector));
            });
        }
    }
    subtree(root) {
        return this._filterMany(e.subtree(root, this._unionSelector));
    }
    _firstSelectorMatch(fn) {
        return u.findResult(this._selectors, (selector) => {
            return this._filterMany(fn(selector))[0];
        });
    }
    _passesFilter(element) {
        return element && u.every(this._filters, (filter) => filter(element));
    }
    _filterOne(element) {
        return u.presence(element, this._passesFilter.bind(this));
    }
    _filterMany(elements) {
        return u.filter(elements, this._passesFilter.bind(this));
    }
};
